<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row>
          <v-col align="stretch" height="200" v-for="n in 100" :key="n" cols="12" sm="6" md="3">
            <v-card
              @click.stop="sayHi('Conrad has ' + n + ' kr')"
              class="pa-3 mx-auto"
              width="250"
            >Conrad har {{n*100}} kr</v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Printer from '../components/Printer';
import isReachable from 'is-reachable';

export default {
  methods: {
    sayHi(ref) {
      console.log('hi from ' + ref);
    },

    async pollData(caller) {
      let test = setInterval(() => {
        //console.log('pollData(): trying to get data');
        let test2 = this.getA('pollData');
      }, 10000);
      console.log(caller);
    },
    async getA(caller) {
      //console.log('getA():', await isReachable('192.168.50.25'));

      console.log(caller);
      if (this.url) {
        let test2 = await isReachable(this.url);
        this.printerStatus = test2 ? 'online' : 'offline';
      }

      return 'yadada';
    }
  },
  beforeCreate: function() {
    this.$store.dispatch('getSettings');
    this.$store.dispatch('getPapers');
    this.$store.dispatch('getJobs');
  },
  async created() {
    this.pollData('created');

    //console.log(2);

    // this.pollData();
  },
  beforeDestroy() {
    clearInterval(this.printerStatus);
  },
  watch: {
    printerStatus: function() {
      // Use of Date.now() function
      var d = Date(Date.now());

      // Converting the number of millisecond in date string
      let a = d.toString();

      console.log('Watcher: Printer is now:', this.printerStatus, a);
    }
  },
  computed: {
    jobs() {
      return this.$store.getters.getJobs;
    },
    papers() {
      return this.$store.getters.getPapers;
    },
    settings() {
      return this.$store.getters.getSettings;
    }
  },
  data() {
    return {
      printerStatus: false,
      int: 0,
      url: 'http://192.168.50.25',
      dialog: false
    };
  }
};
</script>

<style scoped>
</style>